import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e6e4cac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ps-0" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column gap-2 mb-3"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "texto" }, "Loja", -1))
const _hoisted_4 = {
  key: 1,
  class: "d-flex flex-column gap-2 mb-3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "texto" }, "Consultor", -1))
const _hoisted_6 = {
  key: 2,
  class: "d-flex flex-column gap-2 mb-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "texto" }, "Grupos", -1))
const _hoisted_8 = { class: "d-flex flex-column gap-3 mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "texto" }, "Mês", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "FilterCustos",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    onSearch: _cache[7] || (_cache[7] = ($event: any) => (_ctx.enviarEmit()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _createVNode(_component_el_button_group, { class: "col-12 mb-6" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "danger",
              class: _normalizeClass([_ctx.show === 'lojas' ? 'bg-danger border-bottom border-bottom-success' : '', "col-4"]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = 'lojas'))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Lojas")
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_el_button, {
              type: "danger",
              class: _normalizeClass([_ctx.show === 'grupo' ? 'bg-danger border-bottom border-bottom-success' : '', "col-4"]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = 'grupo'))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Grupo")
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_el_button, {
              type: "danger",
              class: _normalizeClass([_ctx.show === 'consultor' ? 'bg-danger border-bottom border-bottom-success' : '', "col-4"]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = 'consultor'))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Consultor")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        (_ctx.show === 'lojas')
          ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_el_select, {
                modelValue: _ctx.paramsFilter.lojas,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paramsFilter.lojas) = $event)),
                placeholder: "Loja",
                clearable: "",
                filterable: "",
                multiple: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojas, (loja, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: loja.nome,
                      value: loja.codConcessionaria,
                      key: key
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.show === 'consultor')
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_select, {
                modelValue: _ctx.paramsFilter.consultor,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paramsFilter.consultor) = $event)),
                placeholder: "Consultor",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consultores, (consultor, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: consultor.name,
                      value: consultor.id,
                      key: key
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.show === 'grupo')
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_el_select, {
                modelValue: _ctx.paramsFilter.grupo,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paramsFilter.grupo) = $event)),
                placeholder: "Grupos",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grupos, (grupo, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: grupo.nome,
                      value: grupo.id,
                      key: key
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.paramsFilter.dataInicio,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paramsFilter.dataInicio) = $event)),
                type: "month",
                format: "MM/YYYY",
                class: "w-100",
                placeholder: "MM/DD/AAAA",
                "default-value": new Date()
              }, null, 8, ["modelValue", "default-value"])
            ]),
            _: 1
          }, 8, ["locale"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}